module.exports = __webpack_public_path__ + "static/media/academyOne.e8ec866d.mp4";